module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.printer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.printer, "companyId", $$v)
      },
      expression: "printer.companyId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.printerName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrinterName)); }]
    },
    model: {
      value: (_vm.printer.name),
      callback: function($$v) {
        _vm.$set(_vm.printer, "name", $$v)
      },
      expression: "printer.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.manufacturer,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingManufacturer)); }]
    },
    model: {
      value: (_vm.printer.manufacturer),
      callback: function($$v) {
        _vm.$set(_vm.printer, "manufacturer", $$v)
      },
      expression: "printer.manufacturer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.model,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingModel)); }]
    },
    model: {
      value: (_vm.printer.model),
      callback: function($$v) {
        _vm.$set(_vm.printer, "model", $$v)
      },
      expression: "printer.model"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.ipAddress,
      "disabled": _vm.pdfPrinter
    },
    model: {
      value: (_vm.printer.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.printer, "ipAddress", $$v)
      },
      expression: "printer.ipAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.portNumber,
      "disabled": _vm.pdfPrinter,
      "rules": [function (v) { return _vm.checkPort(v); }]
    },
    model: {
      value: (_vm.printer.portNumber),
      callback: function($$v) {
        _vm.$set(_vm.printer, "portNumber", $$v)
      },
      expression: "printer.portNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.actions.selectPrinterCategories,
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.sortedCategories
    },
    model: {
      value: (_vm.printer.printerCategories),
      callback: function($$v) {
        _vm.$set(_vm.printer, "printerCategories", $$v)
      },
      expression: "printer.printerCategories"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.notes,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.printer.notes),
      callback: function($$v) {
        _vm.$set(_vm.printer, "notes", $$v)
      },
      expression: "printer.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.pdfPrinter,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.pdfPrinter),
      callback: function($$v) {
        _vm.pdfPrinter = $$v
      },
      expression: "pdfPrinter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e98202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/printers/PrinterDetails.vue
// module id = 437
// module chunks = 35